import { getTrialDaysLeft } from '@atlassian/jira-growth-utils';
import { SOFTWARE } from '@atlassian/jira-shared-types';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller';

export function useTrialDetails() {
	const { productEntitlementDetails, appEditions } = useTenantContext();
	const jswEdition = appEditions?.software;

	const entitlementDetails = productEntitlementDetails?.[SOFTWARE];

	const billingSourceSystem = entitlementDetails?.billingSourceSystem;
	const trialEndTime = entitlementDetails?.trialEndTime;
	const trialDaysLeft = getTrialDaysLeft(trialEndTime);
	const isInTrial = !!trialDaysLeft && trialDaysLeft > 0;

	return { jswEdition, billingSourceSystem, trialDaysLeft, isInTrial, trialEndTime };
}
